import { comparisons } from './ConditionalVisibility';
function getConditionInputs(depth = 1) {
    const inputs = [
        {
            name: 'source',
            type: 'string',
            required: true,
            helperText: 'The value being compared against. It should always be bound to dynamic data so that it is set on a per-user basis when a page is visited.',
        },
        {
            name: 'comparison',
            type: 'string',
            enum: Object.values(comparisons),
            required: true,
        },
        {
            name: 'target',
            type: 'string',
            helperText: 'The value used in the comparison against the source value',
        },
    ];
    if (depth < 3) {
        inputs.push({
            name: 'andConditions',
            friendlyName: 'AND conditions',
            type: 'list',
            subFields: getConditionInputs(depth + 1),
            helperText: 'Additional conditions that all must evaluate to true in order for the root condition to be satisfied',
        });
        inputs.push({
            name: 'orConditions',
            friendlyName: 'OR conditions',
            type: 'list',
            subFields: getConditionInputs(depth + 1),
            helperText: 'Additional conditions that will be evaluated if the root condition (plus AND conditions) is false. If any of them evaluate to true, the root condition will be satisfied.',
        });
    }
    return inputs;
}
export const conditionalVisibilityConfig = {
    name: 'ConditionalVisibility',
    image: 'https://cdn.zappy.app/b24097ecc0dc234bab218993c34b86e5.svg',
    category: 'Zapier Utilities',
    canHaveChildren: true,
    inputs: [
        ...getConditionInputs(),
        {
            name: 'preview',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map